import { importsActions } from '@sonar-software/sonar-imports';
import { SyncStatusNotification } from './notifications';
import React, { useCallback } from 'react';
import { useAction, useAuthToken, useInterval, useOnMount } from '@hooks';

export interface SalesforceSyncWatcherProps {
    showNotifications?: boolean;
}

const REFRESH_INTERVAL = 10 * 1000;

export const SalesforceSyncWatcher: React.FC<SalesforceSyncWatcherProps> = ({ showNotifications }) => {
	const { organizationId } = useAuthToken();
	const getLatest = useAction(importsActions.requestGetImportsLatestSalesforce);

	const getLatestIfAble = useCallback(() => {
		if (!organizationId) {
			return;
		}

		getLatest();
	}, [ getLatest, organizationId ]);

	useOnMount(() => {
		getLatestIfAble();
	});

	useInterval(() => {
		getLatestIfAble();
	}, REFRESH_INTERVAL);

	if (!showNotifications) {
		return null;
	}

	return <SyncStatusNotification />;
};
